export var CAN_NOT_BE_SANITIZED = 'can-not-be-sanitized';
export var CAN_NOT_BE_PARSED = 'can-not-be-parsed';
export var VALID = 'valid';
export var INVALID = 'invalid';
export var NOT_SURE = 'notSure';